const _c0 = (a0, a1) => ({
  $implicit: a0,
  closeFn: a1
});
const _c1 = a0 => ({
  $implicit: a0
});
function ToastItem_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ToastItem_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ToastItem_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.headlessTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c0, ctx_r0.message, ctx_r0.onCloseIconClick));
  }
}
function ToastItem_Conditional_3_ng_container_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r0.cn(ctx_r0.cx("messageIcon"), ctx_r0.message == null ? null : ctx_r0.message.icon));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("messageIcon"));
  }
}
function ToastItem_Conditional_3_ng_container_1_Conditional_2_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r0.cx("messageIcon"));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("messageIcon"));
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function ToastItem_Conditional_3_ng_container_1_Conditional_2_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r0.cx("messageIcon"));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("messageIcon"));
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function ToastItem_Conditional_3_ng_container_1_Conditional_2_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 13);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r0.cx("messageIcon"));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("messageIcon"));
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function ToastItem_Conditional_3_ng_container_1_Conditional_2_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r0.cx("messageIcon"));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("messageIcon"));
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function ToastItem_Conditional_3_ng_container_1_Conditional_2_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r0.cx("messageIcon"));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("messageIcon"));
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function ToastItem_Conditional_3_ng_container_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, ToastItem_Conditional_3_ng_container_1_Conditional_2_Case_0_Template, 1, 4, ":svg:svg", 7)(1, ToastItem_Conditional_3_ng_container_1_Conditional_2_Case_1_Template, 1, 4, ":svg:svg", 8)(2, ToastItem_Conditional_3_ng_container_1_Conditional_2_Case_2_Template, 1, 4, ":svg:svg", 9)(3, ToastItem_Conditional_3_ng_container_1_Conditional_2_Case_3_Template, 1, 4, ":svg:svg", 10)(4, ToastItem_Conditional_3_ng_container_1_Conditional_2_Case_4_Template, 1, 4, ":svg:svg", 8);
  }
  if (rf & 2) {
    let tmp_4_0;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional((tmp_4_0 = ctx_r0.message.severity) === "success" ? 0 : tmp_4_0 === "info" ? 1 : tmp_4_0 === "error" ? 2 : tmp_4_0 === "warn" ? 3 : 4);
  }
}
function ToastItem_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵconditionalCreate(1, ToastItem_Conditional_3_ng_container_1_Conditional_1_Template, 1, 3, "span", 2)(2, ToastItem_Conditional_3_ng_container_1_Conditional_2_Template, 5, 1);
    i0.ɵɵelementStart(3, "div", 6)(4, "div", 6);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 6);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.message.icon ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pBind", ctx_r0.ptm("messageText"))("ngClass", ctx_r0.cx("messageText"));
    i0.ɵɵattribute("data-p", ctx_r0.dataP);
    i0.ɵɵadvance();
    i0.ɵɵproperty("pBind", ctx_r0.ptm("summary"))("ngClass", ctx_r0.cx("summary"));
    i0.ɵɵattribute("data-p", ctx_r0.dataP);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.message.summary, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("pBind", ctx_r0.ptm("detail"))("ngClass", ctx_r0.cx("detail"));
    i0.ɵɵattribute("data-p", ctx_r0.dataP);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.message.detail);
  }
}
function ToastItem_Conditional_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ToastItem_Conditional_3_Conditional_3_Conditional_2_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r0.cn(ctx_r0.cx("closeIcon"), ctx_r0.message == null ? null : ctx_r0.message.closeIcon));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("closeIcon"));
  }
}
function ToastItem_Conditional_3_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ToastItem_Conditional_3_Conditional_3_Conditional_2_span_0_Template, 1, 3, "span", 17);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r0.message.closeIcon);
  }
}
function ToastItem_Conditional_3_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 18);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r0.cx("closeIcon"));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("closeIcon"));
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function ToastItem_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 15);
    i0.ɵɵlistener("click", function ToastItem_Conditional_3_Conditional_3_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onCloseIconClick($event));
    })("keydown.enter", function ToastItem_Conditional_3_Conditional_3_Template_button_keydown_enter_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onCloseIconClick($event));
    });
    i0.ɵɵconditionalCreate(2, ToastItem_Conditional_3_Conditional_3_Conditional_2_Template, 1, 1, "span", 2)(3, ToastItem_Conditional_3_Conditional_3_Conditional_3_Template, 1, 4, ":svg:svg", 16);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("pBind", ctx_r0.ptm("closeButton"));
    i0.ɵɵattribute("class", ctx_r0.cx("closeButton"))("aria-label", ctx_r0.closeAriaLabel)("data-p", ctx_r0.dataP);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.message.closeIcon ? 2 : 3);
  }
}
function ToastItem_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, ToastItem_Conditional_3_ng_container_1_Template, 8, 12, "ng-container", 5)(2, ToastItem_Conditional_3_ng_container_2_Template, 1, 0, "ng-container", 3);
    i0.ɵɵconditionalCreate(3, ToastItem_Conditional_3_Conditional_3_Template, 4, 5, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.cn(ctx_r0.cx("messageContent"), ctx_r0.message == null ? null : ctx_r0.message.contentStyleClass));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("messageContent"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.template);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c1, ctx_r0.message));
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.message == null ? null : ctx_r0.message.closable) !== false ? 3 : -1);
  }
}
const _c2 = ["message"];
const _c3 = ["headless"];
function Toast_p_toastItem_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-toastItem", 1);
    i0.ɵɵlistener("onClose", function Toast_p_toastItem_0_Template_p_toastItem_onClose_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onMessageClose($event));
    })("onAnimationEnd", function Toast_p_toastItem_0_Template_p_toastItem_onAnimationEnd_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onAnimationEnd());
    })("onAnimationStart", function Toast_p_toastItem_0_Template_p_toastItem_onAnimationStart_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onAnimationStart());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const msg_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("message", msg_r3)("index", i_r4)("life", ctx_r1.life)("clearAll", ctx_r1.clearAllTrigger())("template", ctx_r1.template || ctx_r1._template)("headlessTemplate", ctx_r1.headlessTemplate || ctx_r1._headlessTemplate)("pt", ctx_r1.pt)("unstyled", ctx_r1.unstyled())("motionOptions", ctx_r1.computedMotionOptions());
  }
}
export * from 'primeng/types/toast';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, InjectionToken, input, output, EventEmitter, inject, signal, effect, numberAttribute, Output, Input, ChangeDetectionStrategy, ViewEncapsulation, Component, computed, booleanAttribute, ContentChildren, ContentChild, NgModule } from '@angular/core';
import { uuid, isEmpty, setAttribute } from '@primeuix/utils';
import { SharedModule, MessageService, PrimeTemplate } from 'primeng/api';
import { BaseComponent, PARENT_INSTANCE } from 'primeng/basecomponent';
import * as i3 from 'primeng/bind';
import { Bind } from 'primeng/bind';
import { CheckIcon, ExclamationTriangleIcon, InfoCircleIcon, TimesIcon, TimesCircleIcon } from 'primeng/icons';
import * as i2 from 'primeng/motion';
import { MotionModule } from 'primeng/motion';
import { ZIndexUtils } from 'primeng/utils';
import { style } from '@primeuix/styles/toast';
import { BaseStyle } from 'primeng/base';

// Position
const inlineStyles = {
  root: ({
    instance
  }) => {
    const {
      _position
    } = instance;
    return {
      position: 'fixed',
      top: _position === 'top-right' || _position === 'top-left' || _position === 'top-center' ? '20px' : _position === 'center' ? '50%' : null,
      right: (_position === 'top-right' || _position === 'bottom-right') && '20px',
      bottom: (_position === 'bottom-left' || _position === 'bottom-right' || _position === 'bottom-center') && '20px',
      left: _position === 'top-left' || _position === 'bottom-left' ? '20px' : _position === 'center' || _position === 'top-center' || _position === 'bottom-center' ? '50%' : null
    };
  }
};
const classes = {
  root: ({
    instance
  }) => ['p-toast p-component', `p-toast-${instance._position}`],
  message: ({
    instance
  }) => ({
    'p-toast-message': true,
    'p-toast-message-info': instance.message.severity === 'info' || instance.message.severity === undefined,
    'p-toast-message-warn': instance.message.severity === 'warn',
    'p-toast-message-error': instance.message.severity === 'error',
    'p-toast-message-success': instance.message.severity === 'success',
    'p-toast-message-secondary': instance.message.severity === 'secondary',
    'p-toast-message-contrast': instance.message.severity === 'contrast'
  }),
  messageContent: 'p-toast-message-content',
  messageIcon: ({
    instance
  }) => ({
    'p-toast-message-icon': true,
    [`pi ${instance.message.icon}`]: !!instance.message.icon
  }),
  messageText: 'p-toast-message-text',
  summary: 'p-toast-summary',
  detail: 'p-toast-detail',
  closeButton: 'p-toast-close-button',
  closeIcon: ({
    instance
  }) => ({
    'p-toast-close-icon': true,
    [`pi ${instance.message.closeIcon}`]: !!instance.message.closeIcon
  })
};
let ToastStyle = /*#__PURE__*/(() => {
  class ToastStyle extends BaseStyle {
    name = 'toast';
    style = style;
    classes = classes;
    inlineStyles = inlineStyles;
    static ɵfac = /* @__PURE__ */(() => {
      let ɵToastStyle_BaseFactory;
      return function ToastStyle_Factory(__ngFactoryType__) {
        return (ɵToastStyle_BaseFactory || (ɵToastStyle_BaseFactory = i0.ɵɵgetInheritedFactory(ToastStyle)))(__ngFactoryType__ || ToastStyle);
      };
    })();
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ToastStyle,
      factory: ToastStyle.ɵfac
    });
  }
  return ToastStyle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 *
 * Toast is used to display messages in an overlay.
 *
 * [Live Demo](https://www.primeng.org/toast/)
 *
 * @module toaststyle
 *
 */
var ToastClasses = /*#__PURE__*/function (ToastClasses) {
  /**
   * Class name of the root element
   */
  ToastClasses["root"] = "p-toast";
  /**
   * Class name of the message element
   */
  ToastClasses["message"] = "p-toast-message";
  /**
   * Class name of the message content element
   */
  ToastClasses["messageContent"] = "p-toast-message-content";
  /**
   * Class name of the message icon element
   */
  ToastClasses["messageIcon"] = "p-toast-message-icon";
  /**
   * Class name of the message text element
   */
  ToastClasses["messageText"] = "p-toast-message-text";
  /**
   * Class name of the summary element
   */
  ToastClasses["summary"] = "p-toast-summary";
  /**
   * Class name of the detail element
   */
  ToastClasses["detail"] = "p-toast-detail";
  /**
   * Class name of the close button element
   */
  ToastClasses["closeButton"] = "p-toast-close-button";
  /**
   * Class name of the close icon element
   */
  ToastClasses["closeIcon"] = "p-toast-close-icon";
  return ToastClasses;
}(ToastClasses || {});
const TOAST_INSTANCE = /*#__PURE__*/new InjectionToken('TOAST_INSTANCE');
let ToastItem = /*#__PURE__*/(() => {
  class ToastItem extends BaseComponent {
    zone;
    message;
    index;
    life;
    template;
    headlessTemplate;
    showTransformOptions;
    hideTransformOptions;
    showTransitionOptions;
    hideTransitionOptions;
    motionOptions = input(...(ngDevMode ? [undefined, {
      debugName: "motionOptions"
    }] : []));
    clearAll = input(null, ...(ngDevMode ? [{
      debugName: "clearAll"
    }] : []));
    onAnimationStart = output();
    onAnimationEnd = output();
    onBeforeEnter(event) {
      this.onAnimationStart.emit(event.element);
    }
    onAfterLeave(event) {
      if (!this.visible() && !this.isDestroyed) {
        this.onClose.emit({
          index: this.index,
          message: this.message
        });
        if (!this.isDestroyed) {
          this.onAnimationEnd.emit(event.element);
        }
      }
    }
    onClose = new EventEmitter();
    _componentStyle = inject(ToastStyle);
    timeout;
    visible = signal(undefined, ...(ngDevMode ? [{
      debugName: "visible"
    }] : []));
    isDestroyed = false;
    isClosing = false;
    constructor(zone) {
      super();
      this.zone = zone;
      effect(() => {
        if (this.clearAll()) {
          this.visible.set(false);
        }
      });
    }
    onAfterViewInit() {
      this.message?.sticky && this.visible.set(true);
      this.initTimeout();
    }
    initTimeout() {
      if (!this.message?.sticky) {
        this.clearTimeout();
        this.zone.runOutsideAngular(() => {
          this.visible.set(true);
          this.timeout = setTimeout(() => {
            this.visible.set(false);
          }, this.message?.life || this.life || 3000);
        });
      }
    }
    clearTimeout() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    }
    onMouseEnter() {
      this.clearTimeout();
    }
    onMouseLeave() {
      if (!this.isClosing) {
        this.initTimeout();
      }
    }
    onCloseIconClick = event => {
      this.isClosing = true;
      this.clearTimeout();
      this.visible.set(false);
      event.preventDefault();
    };
    get closeAriaLabel() {
      return this.config.translation.aria ? this.config.translation.aria.close : undefined;
    }
    onDestroy() {
      this.isDestroyed = true;
      this.clearTimeout();
      this.visible.set(false);
    }
    get dataP() {
      return this.cn({
        [this.message?.severity]: this.message?.severity
      });
    }
    static ɵfac = function ToastItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToastItem)(i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ToastItem,
      selectors: [["p-toastItem"]],
      inputs: {
        message: "message",
        index: [2, "index", "index", numberAttribute],
        life: [2, "life", "life", numberAttribute],
        template: "template",
        headlessTemplate: "headlessTemplate",
        showTransformOptions: "showTransformOptions",
        hideTransformOptions: "hideTransformOptions",
        showTransitionOptions: "showTransitionOptions",
        hideTransitionOptions: "hideTransitionOptions",
        motionOptions: [1, "motionOptions"],
        clearAll: [1, "clearAll"]
      },
      outputs: {
        onAnimationStart: "onAnimationStart",
        onAnimationEnd: "onAnimationEnd",
        onClose: "onClose"
      },
      features: [i0.ɵɵProvidersFeature([ToastStyle]), i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 10,
      consts: [["container", ""], ["role", "alert", "aria-live", "assertive", "aria-atomic", "true", 3, "pMotionOnBeforeEnter", "pMotionOnAfterLeave", "mouseenter", "mouseleave", "pMotion", "pMotionAppear", "pMotionName", "pMotionOptions", "pBind"], [3, "pBind", "class"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "pBind"], [4, "ngIf"], [3, "pBind", "ngClass"], ["data-p-icon", "check", 3, "pBind", "class"], ["data-p-icon", "info-circle", 3, "pBind", "class"], ["data-p-icon", "times-circle", 3, "pBind", "class"], ["data-p-icon", "exclamation-triangle", 3, "pBind", "class"], ["data-p-icon", "check", 3, "pBind"], ["data-p-icon", "info-circle", 3, "pBind"], ["data-p-icon", "times-circle", 3, "pBind"], ["data-p-icon", "exclamation-triangle", 3, "pBind"], ["type", "button", "autofocus", "", 3, "click", "keydown.enter", "pBind"], ["data-p-icon", "times", 3, "pBind", "class"], [3, "pBind", "class", 4, "ngIf"], ["data-p-icon", "times", 3, "pBind"]],
      template: function ToastItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1, 0);
          i0.ɵɵlistener("pMotionOnBeforeEnter", function ToastItem_Template_div_pMotionOnBeforeEnter_0_listener($event) {
            return ctx.onBeforeEnter($event);
          })("pMotionOnAfterLeave", function ToastItem_Template_div_pMotionOnAfterLeave_0_listener($event) {
            return ctx.onAfterLeave($event);
          })("mouseenter", function ToastItem_Template_div_mouseenter_0_listener() {
            return ctx.onMouseEnter();
          })("mouseleave", function ToastItem_Template_div_mouseleave_0_listener() {
            return ctx.onMouseLeave();
          });
          i0.ɵɵconditionalCreate(2, ToastItem_Conditional_2_Template, 1, 5, "ng-container")(3, ToastItem_Conditional_3_Template, 4, 9, "div", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.cn(ctx.cx("message"), ctx.message == null ? null : ctx.message.styleClass));
          i0.ɵɵproperty("pMotion", ctx.visible())("pMotionAppear", true)("pMotionName", "p-toast-message")("pMotionOptions", ctx.motionOptions())("pBind", ctx.ptm("message"));
          i0.ɵɵattribute("id", ctx.message == null ? null : ctx.message.id)("data-p", ctx.dataP);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.headlessTemplate ? 2 : 3);
        }
      },
      dependencies: [CommonModule, i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, CheckIcon, ExclamationTriangleIcon, InfoCircleIcon, TimesIcon, TimesCircleIcon, SharedModule, Bind, MotionModule, i2.MotionDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return ToastItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Toast is used to display messages in an overlay.
 * @group Components
 */
let Toast = /*#__PURE__*/(() => {
  class Toast extends BaseComponent {
    componentName = 'Toast';
    $pcToast = inject(TOAST_INSTANCE, {
      optional: true,
      skipSelf: true
    }) ?? undefined;
    bindDirectiveInstance = inject(Bind, {
      self: true
    });
    onAfterViewChecked() {
      this.bindDirectiveInstance.setAttrs(this.ptms(['host', 'root']));
    }
    /**
     * Key of the message in case message is targeted to a specific toast component.
     * @group Props
     */
    key;
    /**
     * Whether to automatically manage layering.
     * @group Props
     */
    autoZIndex = true;
    /**
     * Base zIndex value to use in layering.
     * @group Props
     */
    baseZIndex = 0;
    /**
     * The default time to display messages for in milliseconds.
     * @group Props
     */
    life = 3000;
    /**
     * Inline class of the component.
     * @deprecated since v20.0.0, use `class` instead.
     * @group Props
     */
    styleClass;
    /**
     * Position of the toast in viewport.
     * @group Props
     */
    get position() {
      return this._position;
    }
    set position(value) {
      this._position = value;
      this.cd.markForCheck();
    }
    /**
     * It does not add the new message if there is already a toast displayed with the same content
     * @group Props
     */
    preventOpenDuplicates = false;
    /**
     * Displays only once a message with the same content.
     * @group Props
     */
    preventDuplicates = false;
    /**
     * Transform options of the show animation.
     * @group Props
     * @deprecated since v21.0.0. Use `motionOptions` instead.
     */
    showTransformOptions = 'translateY(100%)';
    /**
     * Transform options of the hide animation.
     * @group Props
     * @deprecated since v21.0.0. Use `motionOptions` instead.
     */
    hideTransformOptions = 'translateY(-100%)';
    /**
     * Transition options of the show animation.
     * @group Props
     * @deprecated since v21.0.0. Use `motionOptions` instead.
     */
    showTransitionOptions = '300ms ease-out';
    /**
     * Transition options of the hide animation.
     * @group Props
     * @deprecated since v21.0.0. Use `motionOptions` instead.
     */
    hideTransitionOptions = '250ms ease-in';
    /**
     * The motion options.
     * @group Props
     */
    motionOptions = input(undefined, ...(ngDevMode ? [{
      debugName: "motionOptions"
    }] : []));
    computedMotionOptions = computed(() => {
      return {
        ...this.ptm('motion'),
        ...this.motionOptions()
      };
    }, ...(ngDevMode ? [{
      debugName: "computedMotionOptions"
    }] : []));
    /**
     * Object literal to define styles per screen size.
     * @group Props
     */
    breakpoints;
    /**
     * Callback to invoke when a message is closed.
     * @param {ToastCloseEvent} event - custom close event.
     * @group Emits
     */
    onClose = new EventEmitter();
    /**
     * Custom message template.
     * @param {ToastMessageTemplateContext} context - message context.
     * @see {@link ToastMessageTemplateContext}
     * @group Templates
     */
    template;
    /**
     * Custom headless template.
     * @param {ToastHeadlessTemplateContext} context - headless context.
     * @see {@link ToastHeadlessTemplateContext}
     * @group Templates
     */
    headlessTemplate;
    messageSubscription;
    clearSubscription;
    messages;
    messagesArchieve;
    _position = 'top-right';
    messageService = inject(MessageService);
    _componentStyle = inject(ToastStyle);
    styleElement;
    id = uuid('pn_id_');
    templates;
    clearAllTrigger = signal(null, ...(ngDevMode ? [{
      debugName: "clearAllTrigger"
    }] : []));
    constructor() {
      super();
    }
    onInit() {
      this.messageSubscription = this.messageService.messageObserver.subscribe(messages => {
        if (messages) {
          if (Array.isArray(messages)) {
            const filteredMessages = messages.filter(m => this.canAdd(m));
            this.add(filteredMessages);
          } else if (this.canAdd(messages)) {
            this.add([messages]);
          }
        }
      });
      this.clearSubscription = this.messageService.clearObserver.subscribe(key => {
        if (key) {
          if (this.key === key) {
            this.clearAll();
          }
        } else {
          this.clearAll();
        }
        this.cd.markForCheck();
      });
    }
    clearAll() {
      // trigger signal to clear all messages
      this.clearAllTrigger.set({});
    }
    _template;
    _headlessTemplate;
    onAfterContentInit() {
      this.templates?.forEach(item => {
        switch (item.getType()) {
          case 'message':
            this._template = item.template;
            break;
          case 'headless':
            this._headlessTemplate = item.template;
            break;
          default:
            this._template = item.template;
            break;
        }
      });
    }
    onAfterViewInit() {
      if (this.breakpoints) {
        this.createStyle();
      }
    }
    add(messages) {
      this.messages = this.messages ? [...this.messages, ...messages] : [...messages];
      if (this.preventDuplicates) {
        this.messagesArchieve = this.messagesArchieve ? [...this.messagesArchieve, ...messages] : [...messages];
      }
      this.cd.markForCheck();
    }
    canAdd(message) {
      let allow = this.key === message.key;
      if (allow && this.preventOpenDuplicates) {
        allow = !this.containsMessage(this.messages, message);
      }
      if (allow && this.preventDuplicates) {
        allow = !this.containsMessage(this.messagesArchieve, message);
      }
      return allow;
    }
    containsMessage(collection, message) {
      if (!collection) {
        return false;
      }
      return collection.find(m => {
        return m.summary === message.summary && m.detail == message.detail && m.severity === message.severity;
      }) != null;
    }
    onMessageClose(event) {
      this.messages?.splice(event.index, 1);
      this.onClose.emit({
        message: event.message
      });
      this.onAnimationEnd();
      this.cd.detectChanges();
    }
    onAnimationStart() {
      this.renderer.setAttribute(this.el?.nativeElement, this.id, '');
      if (this.autoZIndex && this.el?.nativeElement.style.zIndex === '') {
        ZIndexUtils.set('modal', this.el?.nativeElement, this.baseZIndex || this.config.zIndex.modal);
      }
    }
    onAnimationEnd() {
      if (this.autoZIndex && isEmpty(this.messages)) {
        ZIndexUtils.clear(this.el?.nativeElement);
      }
    }
    createStyle() {
      if (!this.styleElement) {
        this.styleElement = this.renderer.createElement('style');
        this.styleElement.type = 'text/css';
        setAttribute(this.styleElement, 'nonce', this.config?.csp()?.nonce);
        this.renderer.appendChild(this.document.head, this.styleElement);
        let innerHTML = '';
        for (let breakpoint in this.breakpoints) {
          let breakpointStyle = '';
          for (let styleProp in this.breakpoints[breakpoint]) {
            breakpointStyle += styleProp + ':' + this.breakpoints[breakpoint][styleProp] + ' !important;';
          }
          innerHTML += `
                    @media screen and (max-width: ${breakpoint}) {
                        .p-toast[${this.id}] {
                           ${breakpointStyle}
                        }
                    }
                `;
        }
        this.renderer.setProperty(this.styleElement, 'innerHTML', innerHTML);
        setAttribute(this.styleElement, 'nonce', this.config?.csp()?.nonce);
      }
    }
    destroyStyle() {
      if (this.styleElement) {
        this.renderer.removeChild(this.document.head, this.styleElement);
        this.styleElement = null;
      }
    }
    onDestroy() {
      if (this.messageSubscription) {
        this.messageSubscription.unsubscribe();
      }
      if (this.el && this.autoZIndex) {
        ZIndexUtils.clear(this.el.nativeElement);
      }
      if (this.clearSubscription) {
        this.clearSubscription.unsubscribe();
      }
      this.destroyStyle();
    }
    get dataP() {
      return this.cn({
        [this.position]: this.position
      });
    }
    static ɵfac = function Toast_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Toast)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Toast,
      selectors: [["p-toast"]],
      contentQueries: function Toast_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c2, 5)(dirIndex, _c3, 5)(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headlessTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      hostVars: 5,
      hostBindings: function Toast_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("data-p", ctx.dataP);
          i0.ɵɵstyleMap(ctx.sx("root"));
          i0.ɵɵclassMap(ctx.cn(ctx.cx("root"), ctx.styleClass));
        }
      },
      inputs: {
        key: "key",
        autoZIndex: [2, "autoZIndex", "autoZIndex", booleanAttribute],
        baseZIndex: [2, "baseZIndex", "baseZIndex", numberAttribute],
        life: [2, "life", "life", numberAttribute],
        styleClass: "styleClass",
        position: "position",
        preventOpenDuplicates: [2, "preventOpenDuplicates", "preventOpenDuplicates", booleanAttribute],
        preventDuplicates: [2, "preventDuplicates", "preventDuplicates", booleanAttribute],
        showTransformOptions: "showTransformOptions",
        hideTransformOptions: "hideTransformOptions",
        showTransitionOptions: "showTransitionOptions",
        hideTransitionOptions: "hideTransitionOptions",
        motionOptions: [1, "motionOptions"],
        breakpoints: "breakpoints"
      },
      outputs: {
        onClose: "onClose"
      },
      features: [i0.ɵɵProvidersFeature([ToastStyle, {
        provide: TOAST_INSTANCE,
        useExisting: Toast
      }, {
        provide: PARENT_INSTANCE,
        useExisting: Toast
      }]), i0.ɵɵHostDirectivesFeature([i3.Bind]), i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [[3, "message", "index", "life", "clearAll", "template", "headlessTemplate", "pt", "unstyled", "motionOptions", "onClose", "onAnimationEnd", "onAnimationStart", 4, "ngFor", "ngForOf"], [3, "onClose", "onAnimationEnd", "onAnimationStart", "message", "index", "life", "clearAll", "template", "headlessTemplate", "pt", "unstyled", "motionOptions"]],
      template: function Toast_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, Toast_p_toastItem_0_Template, 1, 9, "p-toastItem", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngForOf", ctx.messages);
        }
      },
      dependencies: [CommonModule, i1.NgForOf, ToastItem, SharedModule],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return Toast;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ToastModule = /*#__PURE__*/(() => {
  class ToastModule {
    static ɵfac = function ToastModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToastModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ToastModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [Toast, SharedModule, SharedModule]
    });
  }
  return ToastModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Toast, ToastClasses, ToastItem, ToastModule, ToastStyle };
